import React, { useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { deleteRole, delSinglebank } from "../../services/Inventory/inventory"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import { deleteEst } from "../../services/estimation/estimation"
import { deleteProject } from "../../services/projectManager/projectMaster"
import {
  deleteledger,
  deleteManufacturingJournal,
} from "../../services/finance/finance"
import LoadingButton from "../Common/LoadingButton"
import { delSingleBloodGroup } from "../../services/Hrms/hrms"
import { deleteSMR } from "../../services/procurement/materialrequest"

const LogoutPopup = ({
  isOpen,
  toggle,
  router,
  logout = false,
  bankdelete = false,
  estimationBudget = false,
  ProjectMaster = false,
  ledgerpop = false,
  ManufacturingJournal = false,
  BloodGroup = false,
  rfq = false,
  smr = false,
  Roles = false,
  deleteId,
  handilRest,
  handilapprow,
  rfqdata,
}) => {
  const [loading, setLoading] = useState(false)
  const handleLogout = async () => {
    if (logout) {
      router.navigate("/logout")
      toggle()
    }

    if (bankdelete && deleteId) {
      setLoading(true)
      try {
        const response = await delSinglebank(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
      }
    }

    if (estimationBudget && deleteId) {
      setLoading(true)
      try {
        const response = await deleteEst(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
      }
    }

    if (ProjectMaster && deleteId) {
      setLoading(true)
      try {
        const response = await deleteProject(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
      }
    } else if (ledgerpop && deleteId) {
      setLoading(true)
      try {
        const response = await deleteledger(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
        setLoading(false)
      }
    } else if (ManufacturingJournal && deleteId) {
      setLoading(true)
      try {
        const response = await deleteManufacturingJournal(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
      }
    } else if (BloodGroup && deleteId) {
      setLoading(true)
      try {
        const response = await delSingleBloodGroup(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
      }
    } else if (smr && deleteId) {
      setLoading(true)
      try {
        const response = await deleteSMR(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
      } catch (err) {
        toastError(err?.message)
        toggle()
      }
    } else if (Roles && deleteId) {
      setLoading(true)
      try {
        const response = await deleteRole(deleteId)
        toggle()
        toastSuccess(response?.message)
        handilRest()
        setLoading(false)
        } catch (err) {
          toastError(err?.message)
          toggle()
          }
    } else if (rfq) {
      setLoading(true)
      handilapprow(rfqdata)
      toggle()
      setLoading(false)
    }
  }

  return (
    <div className="modal-edit">
      <Modal className="modal-custome" isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>
          {logout
            ? `Confirm Logout`
            : bankdelete
            ? `Confirm Delete`
            : rfq
            ? `Confirm Approve`
            : `Confirm Delete`}
        </ModalHeader>
        <ModalBody>
          {logout
            ? `Are you sure you want to log out?`
            : bankdelete
            ? `Are you sure you want to delete this bank?`
            : estimationBudget
            ? `Are you sure you want to delete Estimation?`
            : ProjectMaster
            ? `Are you sure you want to delete?`
            : ledgerpop
            ? `Are you sure you want to delete?`
            : ManufacturingJournal
            ? `Are you sure you want to delete?`
            : BloodGroup
            ? `Are you sure you want to delete Blood Group?`
            : smr
            ? `Are you sure you want to delete SMR?`
            : Roles
            ? `Are you sure you want to delete Roles?`
            : rfq
            ? `Are you sure you want to approve this RFQ?`
            : `Are you sure?`}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>{" "}
          <LoadingButton
            loading={loading}
            color="primary"
            onClick={handleLogout}
          >
            {logout ? "Log out" : bankdelete ? "Delete" : "Confirm"}
          </LoadingButton>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default LogoutPopup
